export const UtilRgb = wcardinal.ui.UtilRgb;